import React, { ReactElement } from "react";

import styles from "./styles.module.scss"
import { Box, Typography, Button } from "@mui/material";
import { Translate } from "react-redux-i18n";
import FontAwesomeIcon from "../FontAwesomeIcon";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { closeDialog } from "redux/dialog/dialogSlice";
import { payedCouponRequested, showPlayedCouponDetails } from "redux/coupon/couponSlice";

export default function ConfirmPayed(): ReactElement {
  const dispatch = useAppDispatch()
  const savedCouponId = useAppSelector(state => state.coupon.payedCouponId)
  const authId = useAppSelector(state => state.auth.authWallet?.id)
  const filters = useAppSelector(state => state.wallet.filters)
  const page = useAppSelector(state => state.wallet.page)
  const rowsPerPage = useAppSelector(state => state.wallet.rowsPerPage)

  const handleCancel = () => {
    dispatch(closeDialog())
  }

  const handleProceed = () => {
    dispatch(payedCouponRequested({
      couponId: savedCouponId,
      authId: authId,
      params: {
        page: page,
        length: rowsPerPage,
        filters: filters
      }
    }))
    dispatch(closeDialog())
    dispatch(showPlayedCouponDetails(false))
  }
  return (
    <Box className={styles.confirmPayedContainer}>
      <Typography className={styles.label}>
        <Translate value="coupon.payConfirm" />
      </Typography>
      <Box className={styles.buttonGroup}>
        <Button
          onClick={() => handleCancel()}
          variant="contained"
          color="error"
          className={styles.cancelButton}
        >
          <FontAwesomeIcon name="x" type="fas" />
          &nbsp; &nbsp;
          <Translate value="coupon.cancel" />
        </Button>

        <Button
          variant="contained"
          color="success"
          onClick={() => handleProceed()}
          className={styles.proceedButton}
        >
          <FontAwesomeIcon name="check" type="fas" />
          &nbsp; &nbsp;
          <Translate value="coupon.proceed" />
        </Button>
      </Box>
    </Box>
  )
}